import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';
import { withGlobalSpinnerActionEnhancer } from '@Utils/Redux/withGlobalSpinnerActionEnhancer';
import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import { addProjectSuccessAction, clearCreatedProjectState } from '@Pages/RetroSynthesis/RetroSynthesisProjects/actions';
import { setIsTransferFromReaction } from '@Pages/RetroSynthesis/ProjectRoute/actions';
import { parseSchemeString } from './utils';
import {
  typeOfMultiStepReactionDialog,
  MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW,
  MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW_SUCCESS,
  MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW_FAILURE,
  MULTISTEP_REACTION_DIALOG_ADD_PROJECT,
  MULTISTEP_REACTION_DIALOG_ADD_PROJECT_SUCCESS,
  MULTISTEP_REACTION_DIALOG_ADD_PROJECT_FAILURE,
  MULTISTEP_REACTION_DIALOG_CLEAR_STATE,
} from './constants';

export const openMultiStepReactionDialog = ({ databaseId, scheme, onClose }) => {
  const { rootReactionId, stepReactionIds } = parseSchemeString(scheme);

  return updateDialog({
    id: typeOfMultiStepReactionDialog,
    dialogType: typeOfMultiStepReactionDialog,
    databaseId,
    rootReactionId,
    stepReactionIds,
    onClose,
    singleReaction: false,
  });
};

export const openMultiStepReactionDialogForSingleReaction = ({ databaseId, reactionId, onClose }) => {
  return updateDialog({
    id: typeOfMultiStepReactionDialog,
    dialogType: typeOfMultiStepReactionDialog,
    databaseId,
    onClose,
    rootReactionId: reactionId,
    stepReactionIds: [reactionId],
    singleReaction: true,
  });
};

export const fetchMultiStepReactionPreview = (params) => {
  return async (dispatch) => {
    dispatch({ type: MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW });

    try {
      const response = await MessageBroker.send(RequestUrls.rsMultiStepPreview, params);
      dispatch({
        type: MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW_FAILURE,
        payload: error,
      });
    }
  };
};

export const submitMultiStepReactionProject = withGlobalSpinnerActionEnhancer(
  ({ databaseId, rootReactionId, stepReactionIds, history }) => {
    return async (dispatch) => {
      dispatch({ type: MULTISTEP_REACTION_DIALOG_ADD_PROJECT });

      try {
        const response = await MessageBroker.send(RequestUrls.rsMultiStepAddProject, {
          databaseId,
          rootReactionId,
          stepReactionIds,
        });
        // eslint-disable-next-line no-use-before-define
        handleSubmitReactionResult(dispatch, response, history);
      } catch (error) {
        dispatch({
          type: MULTISTEP_REACTION_DIALOG_ADD_PROJECT_FAILURE,
          payload: error,
        });
      }
    };
  }
);

export const submitSingleStepReactionProject = withGlobalSpinnerActionEnhancer(({ databaseId, reactionId, history }) => {
  return async (dispatch) => {
    dispatch({ type: MULTISTEP_REACTION_DIALOG_ADD_PROJECT });

    try {
      const response = await MessageBroker.send(RequestUrls.rsSingleStepAddProject, {
        databaseId,
        reactionId,
      });
      // eslint-disable-next-line no-use-before-define
      handleSubmitReactionResult(dispatch, response, history);
    } catch (error) {
      dispatch({
        type: MULTISTEP_REACTION_DIALOG_ADD_PROJECT_FAILURE,
        payload: error,
      });
    }
  };
});

const handleSubmitReactionResult = (dispatch, response, history) => {
  dispatch({
    type: MULTISTEP_REACTION_DIALOG_ADD_PROJECT_SUCCESS,
    payload: response,
  });
  dispatch(addProjectSuccessAction());
  dispatch(clearCreatedProjectState());
  dispatch(setIsTransferFromReaction(true));
  // Redirect to Tree view
  const { id: projectId } = response;
  const routeId = 1;
  // eslint-disable-next-line no-unused-expressions
  history && history.push(RsRoute.getProjectRouteTreeViewLink(projectId, routeId));
};

export const multiStepReactionDialogClearState = () => ({
  type: MULTISTEP_REACTION_DIALOG_CLEAR_STATE,
});
